var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-quick-tour',{attrs:{"height":_vm.videoHeight,"video-name":"Intro1_StoryMode"}},[_c('h4',{staticClass:"my-3 my-xl-0 font-outfit-medium"},[_vm._v(" "+_vm._s(_vm.$t('welcomeToBusinessGuide'))+" ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('businessGuideQuickTourText'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }